import type { IGI18NTextProps } from './types';

import { Text } from '@shopify/polaris';
import { Fragment } from 'react';

export const GI18NText = (props: IGI18NTextProps) => {
  const { children, transformers } = props;

  if (!transformers || Object.values(transformers).length === 0) {
    return <Text {...props}>{children}</Text>;
  }

  const transformContent = (text: string) => {
    const regex = /\[(\d+)\](.*?)\[\]/g;
    const parts: React.ReactNode[] = [];
    let lastIndex = 0;

    text.replace(regex, (match, number, childrenContent, offset) => {
      parts.push(text.slice(lastIndex, offset));
      const transformerFunction = transformers[number];
      if (transformerFunction && typeof transformerFunction === 'function') {
        parts.push(transformerFunction(childrenContent));
      } else {
        parts.push(match);
      }
      lastIndex = offset + match.length;
      return match;
    });
    parts.push(text.slice(lastIndex));

    return parts.map((part, index) => <Fragment key={index}>{part}</Fragment>);
  };

  return (
    <Text {...props}>{typeof children === 'string' ? transformContent(children) : children}</Text>
  );
};
